import React from 'react';

const PlaceholderImage = ({ className = '' }) => {
    return (
        <div className={`flex items-center justify-center bg-gray-200 h-full w-full ${className}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-16 h-16 text-gray-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
        </div>
    );
};

export default PlaceholderImage; 